import React from "react";
import LibraryComponent from "components/library/LibraryComponent";
import { WithLogin } from "HOC/WithLogin";

const Library = () => {
  return <LibraryComponent />;
};

export default WithLogin(Library);
